module.exports = __webpack_public_path__ + "img/szjc8.768abb70.png";